import { CurrentOrganization } from "@core/organization";
var lastSeenProject = "lastSeenProject";
var getProjectId = function() {
    var orgId = CurrentOrganization.getId();
    var ref;
    return (ref = localStorage.getItem("".concat(lastSeenProject, "_").concat(orgId))) !== null && ref !== void 0 ? ref : null;
};
var setProjectId = function(projectId) {
    var orgId = CurrentOrganization.getId();
    localStorage.setItem("".concat(lastSeenProject, "_").concat(orgId), projectId);
};
export var ProjectLocalStorage = {
    getProjectId: getProjectId,
    setProjectId: setProjectId
};

//# sourceMappingURL=ProjectLocalStorage.js.map